import { Button, Flex, Tooltip, Typography } from 'antd';
import cn from 'classnames';

import placeholderImage from '@/lib/assets/placeholder.jpg';
import Platforms from '@/pages/app/dashboard/creators/platforms';

import styles from './styles.module.css';

type TProps = {
	record: any;
	isForModal?: boolean;
};

export default function InfoPopover({ record, isForModal = false }: TProps) {
	// if (isForModal) {
	//   console.log("record", record);
	// }

	const platformHandle =
		record?.creator?.platformHandles?.[0] || record?.creatorUrls?.[0];
	const creatorName = record?.creator?.profileName || record?.creatorName;
	const imageUrl = record?.video?.thumbnail
		? record?.video?.thumbnail
		: record?.thumbnail
		? record?.thumbnail
		: placeholderImage;
	const title = record?.video?.title || record?.title;

	return (
		<Flex
			vertical
			gap={isForModal ? 2 : 8}
			className={cn(styles.popoverContent, isForModal && styles.noMaxWidth)}
			align="center"
		>
			{imageUrl && (
				<img
					key={record?.url}
					src={imageUrl}
					style={{
						width: '120px',
						height: record?.platform === 'youtube' ? '90px' : 'auto',
						backgroundColor: '#f0f0f0',
					}}
					onError={(e) => {
						e.currentTarget.src = placeholderImage;
					}}
					alt="video thumbnail"
				/>
			)}
			<Flex vertical justify="center" align="center">
				{isForModal && (
					<Button type="link" href={record?.url} target="_blank">
						<span
							style={{
								width: '100%',
								display: 'inline-block',
								overflow: 'hidden',
								textOverflow: 'ellipsis',
							}}
						>
							{record?.url?.replace('https://www.', '')}
						</span>
					</Button>
				)}
				{isForModal && title ? (
					<span
						className={styles.popoverText}
						style={isForModal ? { textAlign: 'center' } : {}}
					>
						{title || record?.url}{' '}
					</span>
				) : isForModal && !title ? null : (
					<span
						className={styles.popoverText}
						style={isForModal ? { textAlign: 'center' } : {}}
					>
						{title || record?.url}{' '}
					</span>
				)}
			</Flex>

			<Flex
				gap={4}
				align="center"
				justify={isForModal ? 'center' : 'flex-start'}
				style={{ width: '100%' }}
			>
				<Tooltip title={record?.platform}>
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
						}}
					>
						<Platforms platform={record?.platform} />
					</div>
				</Tooltip>
				{platformHandle ? (
					<Button
						type="link"
						href={platformHandle}
						target="_blank"
						style={{
							width: 'fit-content',
							display: 'flex',
							wordWrap: 'break-word',
							overflow: 'hidden',
							padding: 0,
						}}
					>
						<span
							style={{
								width: '100%',
								display: 'inline-block',
								overflow: 'hidden',
								textOverflow: 'ellipsis',
							}}
						>
							{creatorName}
						</span>
					</Button>
				) : (
					<Typography.Text
						style={{
							width: '100%',
							display: 'inline-block',
							overflow: 'hidden',
							textOverflow: 'ellipsis',
						}}
					>
						{creatorName}
					</Typography.Text>
				)}
			</Flex>
		</Flex>
	);
}
